import { getRetailerOrders, getRetailerOrderFilters, downloadReports } from './api/retailers';
import { alertError } from './alert';
import {
  REPLENISH_ORDERS_LOADING,
  REPLENISH_ORDERS_FILTERS,
  REPLENISH_ORDERS_FILTER_DATA,
  REPLENISH_ORDERS_COUNT,
  REPLENISH_ORDERS_OFFSET,
  REPLENISH_ORDERS_PER_PAGE,
  REPLENISH_ORDERS_SEARCH,
  REPLENISH_ORDERS_SORT,
  REPLENISH_ORDERS_STATUS_COUNT,
  REPLENISH_ORDERS_REPORT,
  REPLENISH_ORDERS_REPORT_CLOSE,
} from '../constants/replenishOrdersTypes';

import { ORDER_TYPE_REPLENISH, ORDER_TYPE_REORDER } from '../../constants/orderTypes';
import { filterOrdersByStates } from '../../utils/orderTableHelper';
import { getTotalCountHeader } from './api/utils';

export const setReplenishOrdersLoading = (value) => ({ type: REPLENISH_ORDERS_LOADING, payload: value });
export const setReplenishOrdersFilters = (filters) => ({ type: REPLENISH_ORDERS_FILTERS, payload: filters });

const filterData = (data, title) => ({
  type: REPLENISH_ORDERS_FILTER_DATA,
  payload: {
    data,
    title,
  },
});

const setReplenishOrdersCount = (count) => ({ type: REPLENISH_ORDERS_COUNT, payload: { all: count } });

export const setReplenishOrdersOffset = (offset) => (dispatch) => {
  dispatch({ type: REPLENISH_ORDERS_OFFSET, payload: offset });
  dispatch(getReplenishOrders());
};

export const setReplenishOrdersPerPage = (perPage) => (dispatch) => {
  dispatch({ type: REPLENISH_ORDERS_PER_PAGE, payload: +perPage });
  dispatch({ type: REPLENISH_ORDERS_OFFSET, payload: 0 });
  dispatch(getReplenishOrders());
};

export const setReplenishOrdersSearchById = (search) => (dispatch) => {
  dispatch({ type: REPLENISH_ORDERS_SEARCH, payload: search });
  dispatch(getReplenishOrders());
};

export const setReplenishOrdersSort = (field) => (dispatch) => {
  dispatch({ type: REPLENISH_ORDERS_SORT, payload: field });
  dispatch(getReplenishOrders());
};

export const getReplenishOrders = (title) => async (dispatch, getState) => {
  dispatch(setReplenishOrdersLoading(true));

  try {
    if (title) {
      dispatch({ type: REPLENISH_ORDERS_OFFSET, payload: 0 });
      dispatch({ type: REPLENISH_ORDERS_SEARCH, payload: '' });
    }

    const state = getState();
    const { retailerId } = state.role;
    const { startDate, endDate } = state.pageFilters.dateRange;
    const { activeCount, offset, perPage, search, sort, field } = state.replenishOrders;

    const filter = {
      created_at: { $between: [startDate, endDate] },
      type: { $in: [ORDER_TYPE_REPLENISH, ORDER_TYPE_REORDER] },
    };

    const title_lower = title ? title.toLowerCase() : activeCount.toLowerCase();
    filterOrdersByStates(filter, title_lower);

    if (search && search !== '') {
      Object.assign(filter, {
        $or: [
          {
            retailer_order_id: {
              $like: `%${search}%`,
            },
          },
          {
            sales_order_number: {
              $like: `%${search}%`,
            },
          },
        ],
      });
    }

    const response = await getRetailerOrders(retailerId, filter, perPage, offset, sort, field);
    const newCount = getTotalCountHeader(response);

    dispatch(filterData(response.data, title ? title : activeCount));
    dispatch({ type: REPLENISH_ORDERS_STATUS_COUNT, payload: newCount });
    dispatch(setReplenishOrdersLoading(false));
  } catch (error) {
    if (!error.message) {
      return false;
    }
    dispatch(alertError(error));
  }
};

export const getReplenishOrdersFilters = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { retailerId } = state.role;
    const { startDate, endDate } = state.pageFilters.dateRange;

    const filter = {
      created_at: { $between: [startDate, endDate] },
      type: { $in: [ORDER_TYPE_REPLENISH, ORDER_TYPE_REORDER] },
    };

    const response = await getRetailerOrderFilters(retailerId, filter);
    const data = response.data;
    const sum = Object.values(data).reduce((a, b) => a + b, 0);

    dispatch(setReplenishOrdersFilters(data));
    dispatch(setReplenishOrdersCount(sum));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const replenishOrdersReport = () => async (dispatch, getState) => {
  const state = getState();

  try {
    const { retailerId } = state.role;
    const { startDate, endDate } = state.pageFilters.dateRange;

    const data = {
      type: 'replenish-orders',
      start_date: startDate.format('YYYY-MM-DD'),
      end_date: endDate.format('YYYY-MM-DD'),
    };

    const response = await downloadReports(retailerId, data);

    if (response.data.success) {
      dispatch({ type: REPLENISH_ORDERS_REPORT });
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const replenishOrdersReportClose = () => ({ type: REPLENISH_ORDERS_REPORT_CLOSE });
